import React from 'react'

const ResultItem = ({title, value, icon, small = false, name}) => {
  return (
    <div className="result-item w-full border-b border-b-grey-lighter mb-5 overflow-hidden">
      <div className={ `result-item-inner ${name === 'images' ? '' : 'max-w-sm' } relative` }>
        <h3 className="result-item-title font-semibold text-red text-sm mb-5">{ title }</h3>
        <div className={`result-item-content inline-block ${ small ? 'text-sm' : 'mb:text-xl1/5 text-lg'} mb-5 font-normal`}>{ name === 'images'? 
          value.map((el,k) => <img key={k} className="w-40 h-40 mr-6 mb-6 object-cover overflow-hidden rounded-lg" src={el} alt="Preview" />)
        : value }</div>
        {icon ? <img src={icon} alt={value} className="w-16 ml-12 md:relative absolute pin-r pin-b md:mb-0 mb-5"/> : null}
      </div>
    </div>
  )
}

export default ResultItem